import { c as _c } from "react/compiler-runtime";
import { TextFieldPropertiesType } from "@website/ui/text-field/text-field.types";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import pick from "lodash-es/pick";
import { ChangeEvent, ChangeEventHandler, FocusEvent, MouseEvent, useRef } from "react";
export const useTextField = properties => {
  const $ = _c(35);
  const {
    onChange,
    onClick,
    type,
    inputMode,
    hasSeparator,
    onFocus,
    onBlur,
    onStartIconClick,
    onEndIconClick
  } = properties;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["number", "tel"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const numberOnly = t0.includes(type ?? "text");
  const inputReference = useRef(null);
  let t1;
  if ($[1] !== onClick) {
    t1 = () => {
      inputReference.current?.focus();
      onClick?.();
    };
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onRootClick = t1;
  let t2;
  if ($[3] !== onFocus) {
    t2 = event => {
      if (onFocus) {
        onFocus(event);
      }
    };
    $[3] = onFocus;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onInputFocus = t2;
  let t3;
  if ($[5] !== onBlur) {
    t3 = event_0 => {
      if (onBlur) {
        onBlur(event_0);
      }
    };
    $[5] = onBlur;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onInputBlur = t3;
  let t4;
  if ($[7] !== onStartIconClick) {
    t4 = event_1 => {
      if (onStartIconClick) {
        event_1.stopPropagation();
        onStartIconClick(event_1);
      }
    };
    $[7] = onStartIconClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onStartIconClickHandler = t4;
  let t5;
  if ($[9] !== onEndIconClick) {
    t5 = event_2 => {
      if (onEndIconClick) {
        event_2.stopPropagation();
        onEndIconClick(event_2);
      }
    };
    $[9] = onEndIconClick;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onEndIconClickHandler = t5;
  let t6;
  if ($[11] !== hasSeparator || $[12] !== numberOnly || $[13] !== onChange || $[14] !== type) {
    t6 = event_3 => {
      if (type !== "file") {
        event_3.target.value = numberConvert(hasSeparator ? numberSeparator(event_3.target.value) : event_3.target.value, {
          locale: "en",
          numberOnly
        });
      }
      onChange?.(event_3 as ChangeEvent<HTMLInputElement> & ChangeEvent<HTMLTextAreaElement>);
    };
    $[11] = hasSeparator;
    $[12] = numberOnly;
    $[13] = onChange;
    $[14] = type;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const handleOnChange = t6;
  let t7;
  if ($[16] !== onRootClick) {
    t7 = {
      onClick: onRootClick
    };
    $[16] = onRootClick;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== properties) {
    t8 = pick(properties, ["disabled", "placeholder", "value", "defaultValue", "min", "max", "type", "readOnly", "required", "data-testid", "name", "maxLength", "autoComplete"]);
    $[18] = properties;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = numberOnly ? "numeric" as const : inputMode;
  let t10;
  if ($[20] !== handleOnChange || $[21] !== onInputBlur || $[22] !== onInputFocus || $[23] !== t8 || $[24] !== t9) {
    t10 = {
      ...t8,
      ref: inputReference,
      onChange: handleOnChange,
      inputMode: t9,
      onFocus: onInputFocus,
      onBlur: onInputBlur
    };
    $[20] = handleOnChange;
    $[21] = onInputBlur;
    $[22] = onInputFocus;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== onStartIconClickHandler) {
    t11 = {
      onClick: onStartIconClickHandler
    };
    $[26] = onStartIconClickHandler;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== onEndIconClickHandler) {
    t12 = {
      onClick: onEndIconClickHandler
    };
    $[28] = onEndIconClickHandler;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t7) {
    t13 = {
      inputReference,
      rootProperties: t7,
      inputProperties: t10,
      startIconProperties: t11,
      endIconProperties: t12
    };
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
    $[33] = t7;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
};